export const DATA_MARQUEE_EVENT_LIMIT = 12
export const FOOTER_REPOSITORY_LIMIT = 12
export const SIGN_UP_URL = '/signup'

const HERO_SEQUENCE_CHAPTER_DURATIONS = [4.466667, 5.766667, 9.166667, 13.433333, 4.566667]

export const HERO_SEQUENCE_CHAPTER_TIMESTAMPS: number[] = HERO_SEQUENCE_CHAPTER_DURATIONS.map((_, index) =>
  HERO_SEQUENCE_CHAPTER_DURATIONS.slice(0, index).reduce((elapsed, duration) => elapsed + duration, 0),
)
